import React from 'react';
import { useServiceClient } from 'common';
import { useMutation } from 'react-query';
import { MyAppsEndPoints, MyAppsQueryKey } from './query-enums';

export const useSendMailQuery = () => {
    const { postData } = useServiceClient();
    const archiveApps = React.useCallback((args: { buildRequestId: string, emailRecepients: string }) => postData(MyAppsEndPoints.SHARE_LINK, {
        BodyTemplate: 'CustomMobileAppDownload',
        BuildRequestId: args.buildRequestId,
        To: args.emailRecepients
    }).then((res) => res.json()), [postData]);
    return useMutation(MyAppsQueryKey.SHARE_LINK, archiveApps);
};
